// @flow
import React from 'react';
import Spinner from '@atlaskit/spinner';
import AvatarAndName from './AvatarAndName';

type Props = {
    jiraUser: any,
};

const User = ({ jiraUser }: Props) => {
    const displayName = jiraUser.jiraUserDisplayName || jiraUser?.displayName;
    const avatarUrl = jiraUser.jiraUserAvatarUrl || jiraUser.avatarUrl || jiraUser?.avatarUrls?.['48x48'];

    if (jiraUser?.jiraUserAccountId === 'unknown') return '';
    if (!displayName) return <Spinner size="small" />;

    return <AvatarAndName displayName={displayName} avatarSrc={avatarUrl} />;
};

export default User;
